import { InjectionToken } from '@angular/core';

export const USE_MOCKED_DATA = new InjectionToken<boolean>('USE_MOCKED_DATA');
